const formatterCache = new Map<string, Intl.DateTimeFormat>();

export function getFormatter(
  locale: string,
  options: Intl.DateTimeFormatOptions,
) {
  const key = locale + JSON.stringify(options);

  if (!formatterCache.has(key)) {
    formatterCache.set(key, new Intl.DateTimeFormat(locale, options));
  }

  return formatterCache.get(key)!;
}
